import { useLocalStorage } from '@fourthwall/utils/dist/LocalStorage';
import { useCreatorSupportChannelsQuery } from '@queries/useCreatorSupportQuery';
import { routing } from '@utils/routing';
import { reverse } from 'named-urls';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSamplesBudgetBalance } from '../../hooks/useSamplesBudgetBalance';
import { useSamplesOffers } from '../../hooks/useSamplesOffers';
import { useCreateSamplesCheckoutMutation } from '../../queries/useCreateSamplesCheckoutMutation';
import { useChallenge } from './hooks/useChallenge';
import { SamplesOrderView } from './SamplesOrderView';
import { isSamplesOrderLocationCartState } from './utils/isSamplesOrderLocationCartState';
import { isSamplesOrderLocationModalState } from './utils/isSamplesOrderLocationModalState';
export const SamplesOrderContainer = () => {
    const { samplesBudgetBalance } = useSamplesBudgetBalance();
    const { localStorage } = useLocalStorage();
    const { createSamplesCheckoutMutation } = useCreateSamplesCheckoutMutation();
    const { samplesOffers } = useSamplesOffers();
    const { getCreatorSupportChannelsQuery } = useCreatorSupportChannelsQuery([{ source: 'SAMPLES' }]);
    const location = useLocation();
    const { challengeDefinitionId, isChallengeActive } = useChallenge();
    const handleSubmit = (values) => {
        values.challengeDefinitionId = challengeDefinitionId;
        return createSamplesCheckoutMutation.mutate([values], {
            onSuccess: (data) => {
                localStorage.set('samples.items', values.items);
                localStorage.set('samples.id', data.checkoutId);
                localStorage.set('samples.supportCalendarUrl', getCreatorSupportChannelsQuery.data?.calendarUrl);
                window.location.assign(reverse(routing.checkout, { checkoutId: data.checkoutId }));
            },
        });
    };
    const getInitialValues = () => {
        if (isSamplesOrderLocationCartState(location.state) && location.state.cart) {
            return location.state.cart;
        }
        if (localStorage.get('samples.items')) {
            return { items: localStorage.get('samples.items') };
        }
    };
    return (React.createElement(SamplesOrderView, { credit: samplesBudgetBalance, offers: samplesOffers.offers, button: { loading: createSamplesCheckoutMutation.isLoading }, initialValues: getInitialValues(), showModal: isSamplesOrderLocationModalState(location.state) && location.state.showModal, isChallengeActive: isChallengeActive, onSubmit: handleSubmit }));
};
